<div class="container modern-container news-page">
  <!-- Page Header with Enhanced Design -->
  <div class="page-header news-header">
    <div class="header-content">
      <div class="header-icon news-icon-wrapper">
        <i class="fas fa-newspaper"></i>
        <div class="icon-pulse"></div>
      </div>
      <div class="header-text">
        <h2 class="page-title">News & Events</h2>
        <p class="page-subtitle">
          <i class="fas fa-bell"></i>Stay updated with latest happenings and events at our college
        </p>
      </div>
    </div>
    <div class="header-badge">
      <i class="fas fa-clock"></i>Updated Daily
    </div>
    <!-- Floating Decorative Elements -->
    <div class="floating-bubble bubble-1"></div>
    <div class="floating-bubble bubble-2"></div>
    <div class="floating-bubble bubble-3"></div>
  </div>

  <div class="card modern-card news-card">
    <div class="card-body">
      <div class="card-header-section">
        <h5 class="card-title">
          <i class="fas fa-bullhorn"></i>Latest News & Upcoming Events
        </h5>
        <span class="news-count-badge">
          <i class="fas fa-list-ul"></i>{{culturalNews?.length || 0}} Items
        </span>
      </div>
      <hr class="title-divider">

      <div class="row">
        <div class="col-lg-12">
          <ul class="list-group modern-list">
            <li class="list-group-item modern-item" *ngFor="let link of culturalNews; let i=index">
              <div class="item-wrapper">
                <div class="item-icon">
                  <i class="fas fa-calendar-check"></i>
                  <span class="item-number">{{i + 1}}</span>
                </div>
                <div class="item-content">
                  <a [href]="link.filename" target="_blank" class="item-link">
                    {{link.displayText}}
                  </a>
                  <span class="item-meta">
                    <i class="fas fa-file-pdf"></i> Click to view document
                  </span>
                </div>
                <div class="item-actions">
                  <button class="btn btn-sm btn-primary" data-bs-toggle="modal" [attr.data-bs-target]="'#newsModal'+i">
                    <i class="fas fa-eye"></i> View
                  </button>
                </div>
              </div>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </div>

  <!-- Info Section -->
  <div class="row mt-4 info-section">
    <div class="col-md-4">
      <div class="info-card">
        <div class="info-icon bg-news">
          <i class="fas fa-rss"></i>
        </div>
        <h5>Campus News</h5>
        <p>Latest updates and announcements from the college administration.</p>
      </div>
    </div>
    <div class="col-md-4">
      <div class="info-card">
        <div class="info-icon bg-events">
          <i class="fas fa-star"></i>
        </div>
        <h5>Events & Activities</h5>
        <p>Upcoming seminars, workshops, and cultural activities.</p>
      </div>
    </div>
    <div class="col-md-4">
      <div class="info-card">
        <div class="info-icon bg-achievements">
          <i class="fas fa-trophy"></i>
        </div>
        <h5>Achievements</h5>
        <p>Celebrating student and faculty accomplishments.</p>
      </div>
    </div>
  </div>
</div>

<!-- PDF Viewer Modals - Outside container for proper z-index -->
<ng-container *ngFor="let link of culturalNews; let i=index">
  <app-pdf-viewer [title]="link.displayText" [url]="link.filename" [id]="'newsModal'+i" [hideButton]="true"></app-pdf-viewer>
</ng-container>